module.exports = __webpack_public_path__ + "img/teams.c489393e.png";